import { Component } from 'react';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Allows `n` animation frames to complete, to allow other components to update
 * and re-render before mounting and rendering an expensive `WrappedComponent`.
 */
export default function withDeferredRender(WrappedComponent, {
  displayName = '',
  Skeleton = __props => /*#__PURE__*/_jsx(_Fragment, {})
} = {}) {
  var _class;
  return _class = class extends Component {
    // `displayName` is helpful for finding the `WrappedComponent` in profiler

    constructor(props, context) {
      super(props, context);
      this.mounted = false;
      this.state = {
        shouldRender: false
      };
    }
    componentDidMount() {
      if (!this.mounted) {
        this.mounted = true;
      }
      let curFrameCount = 0;
      const {
        numFramesToDefer
      } = this.props;
      // callback to update the state to mount the `WrappedCommponent`
      const changeStateValue = () => {
        if (this.mounted) {
          this.setState({
            shouldRender: true
          });
        }
      };

      // a stepper method to step through requested number of frames before rendering
      const step = () => {
        curFrameCount++;
        if (curFrameCount >= numFramesToDefer) {
          window.requestAnimationFrame(changeStateValue);
        } else {
          window.requestAnimationFrame(step);
        }
      };
      step();
    }
    componentWillUnmount() {
      this.mounted = false;
    }
    render() {
      if (this.state.shouldRender) {
        return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props));
      }
      return /*#__PURE__*/_jsx(Skeleton, Object.assign({}, this.props));
    }
  }, _class.displayName = `DeferredRender(${WrappedComponent.name || displayName})`, _class.defaultProps = {
    numFramesToDefer: 2
  }, _class.WrappedComponent = WrappedComponent, _class;
}